import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { selectChat } from '@/store/chat/selectors';

import BreakoutReportWrapper from './components/BreakoutReportWrapper';
import Footer from './components/Footer';
import Header from './components/Header';
import Main from './components/Main';

import { ModelSelectionProvider } from '@/contexts/ModelSelectionContext';
import PropTypes from 'prop-types';

import styles from './Messages.module.scss';

const Messages = ({ socket }) => {
  const { selectedUser, selectedChatTopic } = useSelector(selectChat);
  const { t } = useTranslation('chat');
  const containerRef = useRef(null);

  return (
    <ModelSelectionProvider>
      <div className={styles.messages}>
        {!selectedUser || (selectedUser?.hasTopic && !selectedChatTopic) ? (
          <div className={styles.messages__noUser}>
            <p className={styles.messages__text}>{t('noUser')}</p>
          </div>
        ) : (
          <div className={styles.messages__content}>
            <Header socket={socket} />
            {selectedChatTopic?.withBreakout && <BreakoutReportWrapper />}
            <Main socket={socket} containerRef={containerRef} />
            <Footer socket={socket} containerRef={containerRef} />
          </div>
        )}
      </div>
    </ModelSelectionProvider>
  );
};

Messages.propTypes = {
  socket: PropTypes.shape({
    emit: PropTypes.func,
  }),
};

export default Messages;
